<template>
  <modal
    :headline="$t('productComparison.industryModal.headline')"
    :description="modalDescription"
    class="ce-basketIndustryModal"
    :closable="!needsIndustrySelection"
    @close="submit">
    <div class="ce-modalContent center">
      <div
        class="line-height-3"
        v-if="addToBasketTemp.showHint && !needsIndustrySelection">
        {{ $t('productComparison.singleIndustryHint') }}
      </div>

      <div
        v-if="needsIndustrySelection">
        <div class="mb2 bold ms2">
          {{ $t('productComparison.industryModal.chooseIndustryHeadline') }}
        </div>
        <div
          class="mxn1 flex flex-wrap center justify-center">
          <div
            class="ce-industry"
            v-for="industry in productIndustries"
            :key="industry.code"
            @click.prevent="submit(industry.code)">
            <div>
              <img
                v-if="industry.image"
                :src="industry.image.squarePreview.src"
                :alt="industry.title">
              <template v-else>
                <fa-icon icon="industry" />
              </template>
            </div>
            <div class="mt1 bold">
              {{ industry.title }}
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="addToBasketTemp.industry"
        class="mt4 center">
        <button
          class="ce-btn ce-btn-light"
          @click.prevent="submit">
          {{ $t('productComparison.industryModal.okCta') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('productComparison', ['addToBasketTemp']),
    ...mapState('generic', ['industries']),
    needsIndustrySelection() {
      return !this.addToBasketTemp.industry;
    },
    productIndustries() {
      return this.industries.filter((i) => this.addToBasketTemp.product.industries.indexOf(i.code) > -1);
    },
    modalDescription() {
      return this.needsIndustrySelection
        ? this.$t('productComparison.singleIndustryHint')
        : null;
    }
  },
  methods: {
    ...mapActions('productComparison', ['clearAddToBasketTemp']),
    close() {
      this.clearAddToBasketTemp();
    },
    submit(industry) {
      this.addToBasketTemp.resolvePromise(industry);
      this.close();
    }
  }
};
</script>

<style lang="less">
  @import (reference) "~styles/includes/base";

  .ce-basketIndustryModal {
    .ce-industry {
      width: 100px;
      padding: @space-2;
      border-radius: @border-radius;
      transition: all 250ms ease-in-out;
      cursor: pointer;

      &:hover {
        background: @color-light;
        color: @color-mono-100;
      }

      img {
        width: 100%;
        border-radius: @border-radius;
      }
    }
  }
</style>
